import React, { useEffect, useMemo, useState } from "react";
import HeaderNav from "./HeaderNav";
import LoadingOverlay from "react-loading-overlay";
import BeatLoader from "react-spinners/BeatLoader";
import { Link } from "react-router-dom";

import Modal from "../Modal";

const BreadCrumbs = ({ data }) => {
  return (
    <div className="py-3 px-5 flex flex-row space-x-1">
      {data.map((items, keys) => {
        return (
          <>
            {items.isActive ? (
              <>
                <Link
                  to={items.goTo}
                  className="text-primeColor1 text-sm font-bold"
                >
                  {items.title}
                </Link>
                <div className="text-md"> {">"}</div>
              </>
            ) : (
              <p className="text-gray-700 text-sm font-bold">{items.title}</p>
            )}
          </>
        );
      })}
      <button onClick={() => bcktoTop()} className="bck-btn md:p-2 p-1 md:w-[47px] w-8 md:h-[47px] h-8 z-30 bottom-[85px] md:bottom-[100px] shadow-md">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="md:w-8 w-6 md:h-8 h-6 text-white  transform rotate-90">
          <path
              fill-rule="evenodd"
              d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z"
              clip-rule="evenodd"
          />
          </svg>
      </button>
    </div>
  );
};

const bcktoTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" })
}

const Layout = ({
  children,
  breadCrumbsData = [],
  loading = false,
  popUpShow = false,
  closePopUp = () => {},
}) => {
  const [pseBadgePhase, setPseBadgePhase] = useState("hidden"); // hidden | in | shown | out

  useEffect(() => {
    let t1;
    let t2;
    let t3;
    let intervalId;

    const runCycle = () => {
      // start hidden, then slide in, stay, slide out, back hidden (total 30s)
      setPseBadgePhase("in"); // 0s -> 3s
      t1 = window.setTimeout(() => setPseBadgePhase("shown"), 5000); // 3s -> 15s
      t2 = window.setTimeout(() => setPseBadgePhase("out"), 7000); // 15s -> 18s
      t3 = window.setTimeout(() => setPseBadgePhase("hidden"), 18000); // 18s -> 30s
    };

    runCycle();
    intervalId = window.setInterval(runCycle, 30000);

    return () => {
      window.clearInterval(intervalId);
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      window.clearTimeout(t3);
    };
  }, []);

  const pseBadgeAnimClass = useMemo(() => {
    if (pseBadgePhase === "in") return "animate__animated animate__slideInLeft";
    if (pseBadgePhase === "out") return "animate__animated animate__slideOutLeft";
    return "";
  }, [pseBadgePhase]);

  const _renderBreadCrumbs = () => {
    return (
      <>
        {breadCrumbsData.length !== 0 ? (
          breadCrumbsData.length !== 1 ? (
            <BreadCrumbs data={breadCrumbsData} />
          ) : (
            <div className="py-3"></div>
          )
        ) : (
          <div className="py-3"></div>
        )}
      </>
    );
  };

  const fullYear = () => new Date().getFullYear();
  //get current url
  
  const pathname = window.location.pathname;

  let [isOpen, setIsOpen] = useState(false)
  
  useEffect(() => {

    if(!sessionStorage.getItem('survey_session_id')) {
      sessionStorage.setItem('survey_session_id', Math.random().toString(36).substring(2, 15));
      let seconds = 15
      setTimeout(() => {
        open()
      }, seconds * 1000)
    }
  }, [])
  function open() {
    setIsOpen(true)
  }

  function close() {
    setIsOpen(false)
  }
  const [closeSurvey, setCloseSurvey] = useState(false)

  React.useEffect(() => {
    if(isOpen) {
      setTimeout(() => {
        setCloseSurvey(true)
      }, 10000)
      
    } else {
      setCloseSurvey(false)
    }
  }, [isOpen])

  return (
    <LoadingOverlay
      active={loading}
      spinner={<BeatLoader color={"#36d7b7"} />}
      text="Mohon menunggu..."
    >
      <Modal open={popUpShow} close={closePopUp} />
      <main className="bg-primeColor2 min-h-screen mb-14">
        <HeaderNav />
        {_renderBreadCrumbs()}
        <div className="px-3">{children}</div>
        {
          isOpen && (
            <div className="w-screen flex items-center justify-center absolute left-0 top-0 bg-gray-900/75 h-screen x-[99999]" onClick={close}>
              <div className='mx-auto z-[99999] h-[760px] lg:w-1/3  md:w-1/2 w-full p-3 rounded-md bg-white animate__animated animate__fadeIn relative'>
                <div className="w-full py-2 px-2 bg-white rounded-md animate__animated animate__fadeIn flex flex-col items-center justify-center">
                  <div className="text-center text-lg font-bold">
                  Survey Digital SPBE
                  </div>
                  <div className="absolute top-2 right-2">
                    <button className="text-gray-800 font-semibold py-1 px-2 text-xs border border-gray-800 rounded-full shadow">
                      X
                    </button>
                  </div>
                </div>
                <iframe src="https://surveidigital.spbe.go.id/embed/survey/eyJzdXJ2ZXlfaWQiOjIsInNlcnZpY2VfaWQiOjIyMCwiaG9zdCI6Imh0dHBzOi8vZGFzaGJvYXJkLnN1bWJhcnByb3YuZ28uaWQvLGh0dHA6Ly9sb2NhbGhvc3QiLCJrZXkiOiI0bkt0MzRoeSJ9/embed/view/" 
                referrerPolicy='no-referrer-when-downgrade'
                className='w-full h-[640px] rounded-lg border-2 border-gray-200 shadow-xl'
                frameborder="0"></iframe>
                {
                  closeSurvey && (
                    <div className="w-full py-2 px-2 my-auto bg-white rounded-md animate__animated animate__fadeIn flex flex-col items-center justify-center">
                      <button className="font-semibold py-1 px-2 text-xs border border-gray-800 rounded-full shadow bg-red-500 text-white" onClick={close}>
                        Tutup Survey
                      </button>
                    </div>
                  )
                }
              </div>
            </div>
          )
        }
        <footer
          className="bg-gray-100  mb-0 flex justify-between sm:flex-row flex-col text-gray-700 border-t-2 fixed
              inset-x-0
              bottom-0  border-gray-300 p-2 text-xs "
        >

          <div className="w-full absolute left-1 sm:bottom-14 bottom-24 overflow-hidden pointer-events-none select-none">
            <div
              className={[
                pseBadgePhase === "hidden" ? "hidden" : "block",
                pseBadgeAnimClass,
              ].join(" ")}
              style={{
                // animate.css duration control
                ["--animate-duration"]: "3s",
              }}
            >
              <img
                src="https://pse.layanan.go.id/api/storage/badge/badge_2641.png"
                alt=""
                className="object-contain"
              />
            </div>
          </div>
          <div className="flex flex-col">
            <span className="sr-only">Space Kosong</span>
          </div>
          <div className="font-bold text-center">
            <span className="">
              © {fullYear()} Copyright{" "}
              <a
                href="https://sumbarprov.go.id/"
                target="_blank"
                className="text-red-700"
              >
                Pemerintah Provinsi Sumatera Barat
              </a>
            </span>{" "}
            <br /> <span style={{ color: "#819E43" }}>Dashboard Pembangunan</span> v
            2.1.1 <br />
            {/* Powered by{" "}
            <a
              href="https://diskominfotik.sumbarprov.go.id/"
              target="_blank"
              className="text-blue-500"
            >
              Diskominfotik
            </a> */}
          </div>
          
          <div className="flex w-auto justify-end">
              {
                pathname === "/hotline" ? null :
              
                            <Link to="/hotline" className="sm:block hidden">
                                <div className="text-gray-700 flex flex-row space-x-2 relative justify-center items-center h-full ">
                                    <div className="p-2 bg-primeColor1 rounded-full text-white absolute top-0 -left-2">
                                        <svg dataSlot="icon" fill="none" strokeWidth={2} stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="w-4 h-4">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                                        </svg>
                                    </div>
                                    <div className="p-2 bg-primeColor1 rounded-full text-white animate-ping absolute top-0 -left-4">
                                        <svg dataSlot="icon" fill="none" strokeWidth={2} stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="w-4 h-4">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                                        </svg>
                                    </div>
                                    <div className="bg-primeColor1 py-1 px-4 rounded-full text-white text-xs">
                                      Hubungi Kami
                                    </div>
                                </div>
                            </Link>
              }
          </div>
          {
            pathname === "/hotline" ? null : 
            <Link to="/hotline" className="sm:hidden block absolute -top-10 left-4">
              <div className="text-gray-700 flex flex-row space-x-2 relative justify-center items-center h-full">
                    <div className="p-2 bg-primeColor1 rounded-full border-4 border-white text-white absolute top-0 -left-2">
                        <svg dataSlot="icon" fill="none" strokeWidth={2} stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                        </svg>
                    </div>
                    <div className="p-2 bg-primeColor1 rounded-full border-4 border-yellow-400 text-yellow-400 animate-ping absolute top-0 -left-4">
                        <svg dataSlot="icon" fill="none" strokeWidth={2} stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                        </svg>
                    </div>
              </div>
            </Link>
          }
          
        </footer>
          
      </main>
    </LoadingOverlay>
  );
};

export default Layout;
